// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SX081s {
  width: 700px;
  height: auto;
  border-radius: 0;
  padding: var(--spacing-0-5, 4px);
}

.SX081s [data-testid\$='-header'] {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  background: transparent;
  padding: var(--spacing-3, 24px);
  min-height: auto;
  width: auto;
}

.SX081s [data-testid\$='-close-button'] {
  background: rgba(255, 255, 255, 0.9);
  color: var(--text-neutral-dark);
  width: var(--spacing-4);
  height: var(--spacing-4);
  box-shadow: var(--shadow-sm);
  margin-left: 0;
  transition: var(--transition-all);
}

.SX081s [data-testid\$='-close-button']:hover {
  background: var(--surface-neutral-white, rgba(255, 255, 255, 1));
  transform: scale(1.05);
}

.SX081s [data-testid\$='-body'] {
  padding: 0;
}

@media (max-width: 768px) {
  .SX081s {
    width: 95vw;
    height: 90vh;
    max-width: 400px;
  }

  .sTmwKv {
    height: 50%;
  }

  ._9zctMG {
    padding: var(--spacing-3, 24px);
    gap: var(--spacing-3, 24px);
  }

  .lxFbry {
    font-size: var(--font-size-xl, 20px);
  }

  .iBT4Tx {
    font-size: var(--font-size-sm, 14px);
  }

  .NdgoUS {
    max-width: 100%;
  }

  ._kqXE3 {
    max-width: 100%;
  }
}

.sTmwKv {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: 100%;
  gap: var(--spacing-4, 32px);
  padding: 0;
  background: linear-gradient(
    135deg,
    var(--surface-tertiary-strong, #123015) 0%,
    var(--surface-tertiary-medium, #294437) 100%
  );
  position: relative;
}

._9zctMG {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: var(--spacing-4, 32px);
  padding: var(--spacing-4, 32px) var(--spacing-4, 32px) 43px;
  position: relative;
  background: var(--surface-neutral-white, white);
  text-align: center;
}

.NdgoUS {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 24px);
  width: 100%;
  max-width: 570px;
  margin: 0 auto;
}

.lxFbry {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-2xl, 24px);
  line-height: var(--line-height-160, 1.25);
  color: var(--text-neutral-dark, #333333);
  margin: 0;
  text-align: center;
}

.iBT4Tx {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--type-paragraph-md-font-size, 16px);
  line-height: var(--line-height-160, 1.6);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  text-align: center;
}

._kqXE3 {
  display: flex;
  width: 100%;
  max-width: 300px;
  gap: var(--spacing-2, 16px);
  justify-content: center;
  flex-wrap: wrap;
}

.LSib0y {
  max-width: 420px;
  justify-content: center;
  align-items: center;
}

.SaZm66 {
  gap: var(--spacing-3);
  padding: var(--spacing-5) var(--spacing-3);
}

.PhEgkr {
  gap: var(--spacing-1);
  max-width: 500px;
}

.otke4A {
  max-width: 480px;
}

.JXpeaX {
  width: var(--welcome-onboarding-secondary-width);
  min-width: var(--welcome-onboarding-secondary-width);
  flex-shrink: 0;
  box-sizing: border-box;
}

.RULb8z {
  border-radius: var(--radius-m);
}

.K4Qdhq {
  width: 20px;
  height: 20px;
  margin-right: var(--spacing-2, 16px);
  filter: brightness(0) invert(1);
}

.cOLrPI {
  width: 32px;
  height: 32px;
  filter: invert(21%) sepia(89%) saturate(3068%) hue-rotate(346deg) brightness(102%) contrast(106%);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/WelcomeModal/WelcomeModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;IAC/B,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,UAAU;EACV;;;;GAIC;EACD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,2DAA2D;EAC3D,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iEAAiE;EACjE,6CAA6C;EAC7C,qCAAqC;EACrC,yCAAyC;EACzC,wCAAwC;EACxC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,mDAAmD;EACnD,wCAAwC;EACxC,wCAAwC;EACxC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,oDAAoD;EACpD,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iGAAiG;AACnG","sourcesContent":[".welcomeModal {\n  width: 700px;\n  height: auto;\n  border-radius: 0;\n  padding: var(--spacing-0-5, 4px);\n}\n\n.welcomeModal :global([data-testid$='-header']) {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 10;\n  background: transparent;\n  padding: var(--spacing-3, 24px);\n  min-height: auto;\n  width: auto;\n}\n\n.welcomeModal :global([data-testid$='-close-button']) {\n  background: rgba(255, 255, 255, 0.9);\n  color: var(--text-neutral-dark);\n  width: var(--spacing-4);\n  height: var(--spacing-4);\n  box-shadow: var(--shadow-sm);\n  margin-left: 0;\n  transition: var(--transition-all);\n}\n\n.welcomeModal :global([data-testid$='-close-button']:hover) {\n  background: var(--surface-neutral-white, rgba(255, 255, 255, 1));\n  transform: scale(1.05);\n}\n\n.welcomeModal :global([data-testid$='-body']) {\n  padding: 0;\n}\n\n@media (max-width: 768px) {\n  .welcomeModal {\n    width: 95vw;\n    height: 90vh;\n    max-width: 400px;\n  }\n\n  .header {\n    height: 50%;\n  }\n\n  .content {\n    padding: var(--spacing-3, 24px);\n    gap: var(--spacing-3, 24px);\n  }\n\n  .title {\n    font-size: var(--font-size-xl, 20px);\n  }\n\n  .description {\n    font-size: var(--font-size-sm, 14px);\n  }\n\n  .textContent {\n    max-width: 100%;\n  }\n\n  .actions {\n    max-width: 100%;\n  }\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  height: 100%;\n  gap: var(--spacing-4, 32px);\n  padding: 0;\n  background: linear-gradient(\n    135deg,\n    var(--surface-tertiary-strong, #123015) 0%,\n    var(--surface-tertiary-medium, #294437) 100%\n  );\n  position: relative;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: var(--spacing-4, 32px);\n  padding: var(--spacing-4, 32px) var(--spacing-4, 32px) 43px;\n  position: relative;\n  background: var(--surface-neutral-white, white);\n  text-align: center;\n}\n\n.textContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 24px);\n  width: 100%;\n  max-width: 570px;\n  margin: 0 auto;\n}\n\n.title {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-2xl, 24px);\n  line-height: var(--line-height-160, 1.25);\n  color: var(--text-neutral-dark, #333333);\n  margin: 0;\n  text-align: center;\n}\n\n.description {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--type-paragraph-md-font-size, 16px);\n  line-height: var(--line-height-160, 1.6);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  text-align: center;\n}\n\n.actions {\n  display: flex;\n  width: 100%;\n  max-width: 300px;\n  gap: var(--spacing-2, 16px);\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.actionsSplit {\n  max-width: 420px;\n  justify-content: center;\n  align-items: center;\n}\n\n.contentOnboarding {\n  gap: var(--spacing-3);\n  padding: var(--spacing-5) var(--spacing-3);\n}\n\n.textContentOnboarding {\n  gap: var(--spacing-1);\n  max-width: 500px;\n}\n\n.actionsOnboarding {\n  max-width: 480px;\n}\n\n.onboardingSkipButton {\n  width: var(--welcome-onboarding-secondary-width);\n  min-width: var(--welcome-onboarding-secondary-width);\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.onboardingActionRadius {\n  border-radius: var(--radius-m);\n}\n\n.buttonIcon {\n  width: 20px;\n  height: 20px;\n  margin-right: var(--spacing-2, 16px);\n  filter: brightness(0) invert(1);\n}\n\n.contentIcon {\n  width: 32px;\n  height: 32px;\n  filter: invert(21%) sepia(89%) saturate(3068%) hue-rotate(346deg) brightness(102%) contrast(106%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"welcomeModal": `SX081s`,
	"header": `sTmwKv`,
	"content": `_9zctMG`,
	"title": `lxFbry`,
	"description": `iBT4Tx`,
	"textContent": `NdgoUS`,
	"actions": `_kqXE3`,
	"actionsSplit": `LSib0y`,
	"contentOnboarding": `SaZm66`,
	"textContentOnboarding": `PhEgkr`,
	"actionsOnboarding": `otke4A`,
	"onboardingSkipButton": `JXpeaX`,
	"onboardingActionRadius": `RULb8z`,
	"buttonIcon": `K4Qdhq`,
	"contentIcon": `cOLrPI`
};
module.exports = ___CSS_LOADER_EXPORT___;
